import { PostponeStepSchema } from '@feedyou/schema'

import { UnsetDialogsService } from '../../../types'

export const unsetDialogs: UnsetDialogsService<PostponeStepSchema> = (dialogIds, step) => {
  if (!step.dialog || !dialogIds.includes(step.dialog)) {
    return step
  }
  const newStep = { ...step }
  delete newStep.dialog

  return newStep
}
